/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { CodeSnippet } from './FeelMessageCodeSnippet.styled';

export function FeelMessageCodeSnippet({ children }) {
  const newLinesInText = children?.split(/\r\n|\r|\n/).length;
  return (
    <CodeSnippet
      type={newLinesInText >= 2 ? 'multi' : 'single'}
      minCollapsedNumberOfRows={2}
      maxCollapsedNumberOfRows={5}
      minExpandedNumberOfRows={6}
      wrapText
    >
      {children}
    </CodeSnippet>
  );
}
